<template>
  <div id="edition">
    <header-top></header-top>
    <div class="header-title">版本管理</div>
    <div class="edition-container">
      <div class="container-main">
        <div class="main-left">
          <div class="left-operation">
            <div class="operation-btn">
              <el-tooltip
                placement="top"
                popper-class="custom-tooltip"
                effect="light"
              >
                <div slot="content">添加版本</div>
                <div @click="addEdition">
                  <svg-icon icon-class="add-ico" class="btn-add" />
                </div>
              </el-tooltip>
              <el-tooltip
                placement="top"
                popper-class="custom-tooltip"
                effect="light"
              >
                <div slot="content">删除</div>
                <div @click="delEdition">
                  <svg-icon icon-class="del-ico" class="btn-del" />
                </div>
              </el-tooltip>
            </div>
            <el-input
              class="operation-search"
              placeholder="请输入版本名称"
              suffix-icon="el-icon-search"
              v-model="search"
              clearable
              v-if="editionList.length"
              @keyup.enter.native="enterSearch"
            ></el-input>
          </div>
          <ul class="edition-list">
            <li
              class="edition"
              v-for="(item, index) in editionList"
              :key="index"
              :class="{ 'active-edition': editionOpration == index }"
              @click="selectEdition(index, item)"
            >
              <span>{{ item.displayName }}</span>
            </li>
          </ul>
        </div>
        <div
          class="main-line"
          v-if="editionList.length || operation == 'create'"
        ></div>
        <div
          class="main-right"
          v-if="editionList.length || operation == 'create'"
        >
          <el-tabs v-model="activeTab">
            <el-tab-pane label="基本信息" name="basic-info">
              <basic-info
                ref="basicInfo"
                :operation="operation"
                :editionInfo="editionInfo"
                @newEditionInfo="changeEditionInfo($event)"
              ></basic-info>
            </el-tab-pane>
            <el-tab-pane label="功能配置" name="features">
              <features :id="editionInfo.id"></features>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="main-right-none" v-if='noneVersion&&operation!="create"'>
          <img src="@/assets/image/none-img.png" alt="">
          <div class="none-tips">当前暂无版本，单击下面“立即添加”按钮添加新版本。</div>
          <el-button type="primary" @click="addEdition">立即添加</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import basicInfo from "./basic-info";
import features from "./features";
import {
  getEditions,
  getEditionInfo,
  deleteEdition,
  creatEdition,
  updateEdition,
} from "@/http/api/editions";
import { deepCopy } from "@/utils/deepCopy";
import headerTop from "@/components/HeaderTop";
export default {
  components: {
    basicInfo,
    features,
    headerTop,
  },
  data() {
    return {
      activeTab: "basic-info",
      search: "",
      editionOpration: 0,
      editionList: [],
      operation: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
      noneVersion:false,
      editionInfo: {},
      editions: {},
      editionNode: {},
      permissions: this.$store.getters.permissions,
    };
  },
  mounted() {
    this.getEditionList();
  },
  methods: {
    enterSearch() {
      //console.log(1515, window.event);
      var evt = window.event || e;
      //console.log(evt, 66666);
      if (evt.keyCode == 13) {
        // 回车事件
        this.getEditionList();
      }
    },
    getEditionList() {
      let query = {
        filter: this.search,
      };
      getEditions(query).then((res) => {
        this.editionList = res.result.items;
        if(this.editionList.length==0){
          this.noneVersion = true
        }else{
          this.noneVersion = false
        }
        let id = this.editionList.length
          ? this.editionList[this.editionOpration].id
          : "";
        //console.log(id, 11111);
        this.getEditionDetails(id);
      });
    },
    selectEdition(index, item) {
      this.editionOpration = index;
      this.getEditionDetails(item.id);
      this.operation = "checked";
    },
    getEditionDetails(id) {
      getEditionInfo(id).then((res) => {
        //console.log(res, 123123);
        this.editionInfo = deepCopy(res.result);
      });
    },
    // 删除节点
    delEdition() {
      //console.log(this.editionOpration,'获取的this.editionOpration');
      if (this.permissions["RocketSaas.Editions.Delete"]) {
        this.$confirm(
          `是否删除${this.editionList[this.editionOpration].displayName}？`,
          `删除${this.editionList[this.editionOpration].displayName}`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            deleteEdition(this.editionList[this.editionOpration].id)
              .then((res) => {
                if (res.code == 10200) {
                  this.getEditionList();
                  this.$message.success({ message: res.message });
                } else {
                  this.$message.warning({ message: res.message });
                }
              })
              .catch((err) => {
                this.$message.error({ message: err.message });
              });
          })
          .catch(() => {
            this.$message({
              message: "取消删除",
              showClose: true,
            });
          });
      } else {
        this.$message.warning({
          message: `您暂无删除版本权限`,
          showClose: true,
        });
      }
    },
    addEdition() {
      if (this.permissions["RocketSaas.Editions.Create"]) {
        this.activeTab = "basic-info";
        this.operation = "create";
        this.editionInfo = {};
      } else {
        this.$message.warning({
          message: `您暂无创建版本权限`,
          showClose: true,
        });
      }
    },
    changeEditionInfo() {
      this.getEditionList();
      this.editionUpdataInfo = {};
      this.operation = "checked";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
#edition {
  min-height: calc(100vh - 50px);
  // overflow-y: auto;
  .title {
    color: #000000;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 17px 20px 17px;
    background: rgba(255, 255, 255, 1);
  }

  .svg-icon {
    cursor: pointer;
  }

  .edition-container {
    padding: 20px;

    .container-main {
      display: flex;
      min-height: calc(100vh - 160px);

      .main-left {
        border-radius: $--border-radius-base;
        margin-right: 20px;
      padding: 20px;
        width: 315px;
        background: #fff;
        .left-operation {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .operation-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;

            width: 50px;

            .btn-add {
              width: 10px;
              height: 10px;
            }

            .btn-del {
              width: 16px;
              height: 16px;
              color: #888;
            }
          }

          .operation-search {
            width: 220px;
            height: 30px;
          }
        }
        .edition-list {
          padding-inline-start: 0;
          text-align: left;
          .edition {
            @include flex(row, center);
            width: 305px;
            height: 35px;
            padding-left: 9px;
            font-size: 12px;
            cursor: pointer;
            color: #000000;
          }
          .active-edition {
            background: #e5e5e5;
          }
        }
      }

      .main-right  {
        border-radius: $--border-radius-base;
        padding: 20px;
        overflow: hidden;
        width: calc(100% - 354px);
        background: #fff;
        ::v-deep .el-tabs {
          width: calc(100% + 10px);
          position: relative;
          right: 10px;
          .el-tabs__header{
            box-shadow: 0 2px 3px rgba(0, 0, 0, 0)
          }
          .el-tab-pane {
            min-height: calc(100vh - 299px);
          }
        }
      }
      .main-right-none{
        @include flex(column,center);
        justify-content: center;
        padding: 20px;
        width: calc(100% - 354px);
        background: #fff;
        img{
          margin-bottom: 10px;
          width: 40%;
          height: auto;
        }
        .none-tips{
          margin-bottom: 10px;
          color: #888888;
        }
      }
    }
  }

}
</style>